export default __webpack_public_path__ + "static/media/surgeofbile.a517d573.png";